import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation-modal.html',
  styleUrl: './confirmation-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  @Input() title = 'Cancel changes?';
  @Input() message = 'All data will be erased irrevocably.';
  @Input() icon = 'assets/icons/img_combo-shape.svg';
  @Input() closeLabel = 'Close';
  @Input() confirmLabel = 'Cancel';
  @Input() confirmColor = 'danger'; // 'danger' | 'primary'

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
